import React, { useContext } from "react";

import makeStyles from '@mui/styles/makeStyles';
import { Container } from "@mui/material";
import Grid from "@mui/material/Grid";

import LanguageContext from "../LanguageContext";
import messages from "../services/messages";

import LiveHelpCard from "./LiveHelpCard";

import Skeleton from '@mui/material/Skeleton';

import SectionTitle from "./SectionTitle";

const useStyles = makeStyles((theme) => ({
  root: {
    // display: "flex",
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  container: {
    // border:'solid',
    // borderWidth:'2px',
    // borderColor:'lightgrey'
  },
  contentCard: {
    marginLeft: theme.spacing(2),
  },
}));

export default function LiveHelpContainer(props) {
  const classes = useStyles();
  const language = useContext(LanguageContext);
  const [open, setOpen] = React.useState(true);
  const meetings = props.meetings;

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <div className={classes.root}>
      <Container className={classes.container}>
        {props.meetings && props.meetings.length > 0 && (
          <>
            <SectionTitle
              icon={"icons/live-chat.svg"}
              title={messages["dashboard.liveHelp.sectionTitle"][language]}
              userSource={props?.userSource}
            />

            {meetings.map((meeting) => {
              return (
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  spacing={2}
                  key={meeting.uuid}
                >
                  <Grid item xs={12} sm={12} md={6} lg={4}>
                    <LiveHelpCard
                      meeting={meeting}
                      userType={props.userType}
                      userState={props.userState}
                      userSource={props?.userSource}
                    />
                  </Grid>
                </Grid>
              );
            })}
          </>
        )}
        {props.loading && props.loading === true && (
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
          >
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <Skeleton variant="text" height={25} />
              <br />
              <Skeleton variant="rectangular" height={100} />
            </Grid>
          </Grid>
        )}
      </Container>
    </div>
  );
}
